import { useEffect } from 'react';
import { BRAND } from '@br/protocol';

/** Sets the document title as "<page> · <product>"; product name only when no page is given. */
export function usePageTitle(page?: string): void {
  useEffect(() => {
    document.title = page ? `${page} · ${BRAND.name}` : BRAND.name;
    return () => {
      document.title = BRAND.name;
    };
  }, [page]);
}
